module.exports = __webpack_public_path__ + "static/media/chargeUP.6c3d92b2.png";